import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

import "./style.css";

const AcceptanceDetails = ({ data, setData, setView }) => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleConfirm = async (formData) => {
    const userData = localStorage.getItem("user");
    const user = userData ? JSON.parse(userData) : null;

    const body = {
      master_id: data.id,
      acc_date: formData.acc_date,
      acc_time: formData.acc_time,
      user_id: user.id,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/expo_acceptance/postCargoAcceptance`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        Swal.fire({
          title: "¡Actualizado!",
          text: res.data.message,
          icon: "success",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
        setView("input");
        setData({});
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().slice(0, 5);

    setCurrentDate(date);
    setCurrentTime(time);
    setValue("acc_date", date);
    setValue("acc_time", time);
  }, [setValue]);

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <div className="row">
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Master:</span> {data?.awb}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Origen:</span> {data?.orig}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Destino:</span> {data?.dest}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Piezas Master:</span> {data?.pieces}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Peso Master:</span> {data?.weight}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Volúmen Master:</span> {data.volume}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Tipo de mercancía:</span>{" "}
                {data?.merch}{" "}
              </p>
            </div>
            <div className="col-md-3 mb-2">
              <p>
                <span className="fw-bold">Houses:</span> {data.houses.length}{" "}
              </p>
            </div>
          </div>
          <div className="row mt-4">
            <form
              id="post-cargo-acceptance"
              className="post-cargo-acceptance"
              onSubmit={handleSubmit(handleConfirm)}
            >
              <div className="container mt-2">
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="bold" style={{ fontWeight: "bold" }}>
                          Fecha de entrada:
                        </p>
                        <input
                          type="date"
                          className="form-control inp_acceptance"
                          name="acc_date"
                          id="acc_date"
                          defaultValue={data?.date || currentDate}
                          {...register("acc_date", {
                            required: "Este campo es requerido",
                          })}
                        />
                        {errors.acc_date && (
                          <span
                            role="alert"
                            style={{ color: "#f90102", fontSize: "12px" }}
                          >
                            {errors.acc_date.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <p className="bold" style={{ fontWeight: "bold" }}>
                          Hora de entrada:
                        </p>
                        <input
                          type="time"
                          className="form-control inp_acceptance"
                          name="acc_time"
                          id="acc_time"
                          defaultValue={data?.time || currentTime}
                          {...register("acc_time", {
                            required: "Este campo es requerido",
                          })}
                        />
                        {errors.acc_time && (
                          <span
                            role="alert"
                            style={{ color: "#f90102", fontSize: "12px" }}
                          >
                            {errors.acc_time.message}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btnn"
                          id="openAcceptanceModal"
                        >
                          Aceptar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcceptanceDetails;
